import { useNavigate, useLocation } from 'react-router-dom';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";


export const APP_ROUTES = {
    UNAUTHORIZED: "/unauthorized",
    ERROR: '/error',
    APP: '/applications',
    PRODUCT: '/product',
    REDIRECT: '/redirect',
    HOME: '/',
};

export const useAppNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { instance } = useMsal();

  const urlPath = location.pathname;

  const isLogin = urlPath === APP_ROUTES.LOGIN;
  const isHome = urlPath === APP_ROUTES.HOME;
  const isApplications = urlPath === APP_ROUTES.APP;
  const isProduct = urlPath === APP_ROUTES.PRODUCT;

  return {
    goToApplications: () => navigate(APP_ROUTES.APP),
    goToProduct: () => navigate(APP_ROUTES.PRODUCT),
    goToError: () => navigate(APP_ROUTES.ERROR),
    goToRedirect: () => navigate(APP_ROUTES.REDIRECT),
    goToUnauthorized: () => navigate(APP_ROUTES.UNAUTHORIZED),
    goBack: () => navigate(-1),
    goToLogin: () => instance.loginRedirect(loginRequest),
    isHome,
    isApplications,
    isProduct,
    isLogin,
  };
};
